import { Store } from 'src/store/index';

const getIncludeCanvasHangerKit = (store: Store) => store.design.includeCanvasHangerKit;

export default getIncludeCanvasHangerKit;
